// extracted by css-extract-rspack-plugin
export default {"fullPlanDetailsLink":"HNkqOp_2vA_k3aXV","title":"LaazytMJCJgg4Sn8","viewPlanDetails":"e4VMQXDNSwZPe84b","planSelectorModalContainer":"jczeGobx8s4VAfSL"};